import { render, staticRenderFns } from "./staticform.vue?vue&type=template&id=e938d8a0&scoped=true&"
import script from "./staticform.vue?vue&type=script&lang=js&"
export * from "./staticform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e938d8a0",
  null
  
)

export default component.exports